<template>
  <div>
    <el-card class="box-card">
      <el-form :model="editForm" ref="editForm" label-width="170px">
        <el-form-item class="addAdminForm" label="销售类型">
          <el-select v-model="editForm.saletype" placeholder="请选择">
            <el-option label="直销" value="1"></el-option>
            <el-option label="贴牌" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="addAdminForm" label="是否定制" v-if="editForm.saletype==2">
          <el-select v-model="editForm.isdingzhi" placeholder="请选择">
            <el-option label="不定制" value="1"></el-option>
            <el-option label="定制" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="addAdminForm" label="销售单位">
          <el-select v-model="editForm.salecompany" placeholder="请选择">
            <el-option
              v-for="item in PurchaseCompanyOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="addAdminFormLLL" label="产品名称">
          <div class="productdata1">
            <div class="productdata2">
              <el-select v-model="editForm.projectcode" placeholder="请选择" class="select" style="width: 15%" @change="selectProject()" filterable>
                <el-option
                  v-for="item in ProjectNameList" :key="item.Code" :label="item.Name" :value="item.Code">
                </el-option>
              </el-select>
              订单数量:
              <el-input v-model="editForm.num" style="width: 10%"></el-input>
              订单单价:
              <el-input v-model="editForm.unitprice" :change="processData()" style="width: 10%"></el-input>
              折扣率:
              <el-input v-model="editForm.discountrate" style="width: 10%" disabled></el-input>
              市场价:
              <el-input v-model="editForm.shichangjia" style="width: 10%" disabled></el-input>
              <el-button type="text" @click="clickAddSubProject()">增加</el-button>
            </div>
          </div>
        </el-form-item>
        <el-form-item class="addAdminFormLLL">
          <el-card v-for="item,index in editForm.SubProject" :key="index">
            <li>产品：{{item.Projectname}}；数量：{{item.Num}}；单价：{{item.Unitprice}}；折扣率：{{item.Discountrate}}；市场价：{{item.Shichangjia}}；
            <el-button type="text" @click="clickDeleteSubProject(index)">删除</el-button>
            </li>
          </el-card>
        </el-form-item>
        <el-form-item class="addAdminForm" label="选择客户">
          <el-select v-model="editForm.customerid" placeholder="请选择" class="select" filterable>
            <!-- <el-option label="新增客户信息" value="-1"></el-option> -->
            <el-option
              v-for="item in CustomerInfoList" :key="item.Id" :label="item.Customername" :value="item.Id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="addAdminFormLLL" label="" v-if="editForm.customerid==-1">
          <div class="productdata1">
            <div class="productdata2">
              <el-select v-model="editForm.salesmanid" placeholder="请选择销售员" class="select" @change="selectSalesMan()" filterable>
                <el-option
                  v-for="item in SalesManList" :key="item.Id" :label="item.Manname" :value="item.Id">
                </el-option>
              </el-select>
              <el-select v-model="editForm.gendanmanid" placeholder="请选择跟单员" class="select" filterable>
                <el-option
                  v-for="item in SalesManList" :key="item.Id" :label="item.Manname" :value="item.Id">
                </el-option>
              </el-select>
              客户名称:
              <el-input v-model="editForm.subcustomername" style="width: 12%"></el-input>
              联系方式:
              <el-input v-model="editForm.sublianxifangshi" style="width: 12%"></el-input>
              银行账号:
              <el-input v-model="editForm.subbankaccount" style="width: 12%"></el-input>
              开户行:
              <el-input v-model="editForm.subbankname" style="width: 12%"></el-input>
              备注:
              <el-input v-model="editForm.subbeizhu" style="width: 12%"></el-input>
            </div>
          </div>
        </el-form-item>
        <el-form-item class="addAdminFormLLL" label="金额">
          合同总额:
          <el-input v-model="editForm.amountoriginal" disabled :change="processAmount()" style="width: 12%"></el-input>
          返利:
          <el-input v-model="editForm.amountrebates" :change="processAmount()" style="width: 12%"></el-input>
          订单总金额:
          <el-input v-model="editForm.amount" disabled style="width: 12%"></el-input>
        </el-form-item>
        <el-form-item class="addAdminFormLLL" label="收款信息">
          <div class="productdata1">
            <div class="productdata2">
              收款条件:
              <el-input v-model="editFormsub.Receiptterms" style="width: 20%"></el-input>
              收款时间:
              <el-date-picker v-model="editFormsub.Receipttime" type="date" value-format="yyyy-MM-dd" style="width: 20%"></el-date-picker>
              收款金额:
              <el-input v-model="editFormsub.Receiptamount" style="width: 15%"></el-input>
              <el-button type="text" @click="clickAddSubReceipt()">增加</el-button>
            </div>
          </div>
        </el-form-item>
        <el-form-item class="addAdminFormLLL">
          <el-card v-for="item,index in editForm.SubReceipt" :key="index">
            <li>收款条件：{{item.Receiptterms}}；收款时间：{{item.Receipttime}}；收款金额：{{item.Receiptamount}}；
            <el-button type="text" @click="clickDeleteSubReceipt(index)">删除</el-button>
            </li>
          </el-card>
        </el-form-item>
        <el-form-item class="addAdminForm" label="发货日期">
          <el-date-picker v-model="editForm.sendtime" type="date" value-format="yyyy-MM-dd"></el-date-picker>
        </el-form-item>
        <el-form-item label="发货地址" class="addAdminForm">
          <el-input v-model="editForm.sendaddress"></el-input>
        </el-form-item>
        <el-form-item label="定制文件" class="addAdminForm" v-if="editForm.saletype==2&&editForm.isdingzhi==2">
          <TencentyunCosUploadMultiImgOrPdf ref="MultiImgOrPdf" @change="dingzhifileTencentyunCosUploadMultiImgOrPdf"></TencentyunCosUploadMultiImgOrPdf>
        </el-form-item>
        <el-form-item label="备注(可选)" class="addAdminForm">
          <el-input v-model="editForm.beizhu"></el-input>
        </el-form-item>
        <el-form-item label="附件(可选)" class="addAdminForm">
          <TencentyunCosUploadMultiImgOrPdf ref="MultiImgOrPdf" @change="addTencentyunCosUploadMultiImgOrPdf"></TencentyunCosUploadMultiImgOrPdf>
          默认采用上次的附件，如果附件有改动，请把所有附件都重新上传。
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="clickSave">保存</el-button>
          <el-button type="info" @click="clickReturn">返回</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
import TencentyunCosUploadMultiImgOrPdf from '@/components/TencentyunCosUploadMultiImgOrPdf.vue'
Vue.use(VueAxios, axios)

export default {
  components: {
    TencentyunCosUploadMultiImgOrPdf
  },
  data () {
    return {
      PurchaseCompanyOptions:[],
      ProjectNameList:[],
      SalesManList:[],
      CustomerInfoList:[],
      editForm: {
        id: 0,
        saletype: '1',
        isdingzhi: '1',
        salecompany: '',
        salesmanid: '',
        customerid: '',
        gendanmanid: '',
        amountoriginal: '0',
        amountrebates: '0',
        amount: '0',
        SubReceipt: [],
        sendtime: '',
        sendaddress: '',
        beizhu: '',
        dingzhifile: '',
        attachment: '',
        subcustomername: '',
        sublianxifangshi: '',
        subbankaccount: '',
        subbankname: '',
        subbeizhu: '',
        //产品列表
        SubProject: [],
        //产品列表子元素
        projectcode: '',
        projectname: '',
        projectclassification: '',
        num: '',
        unitprice: '',
        discountrate: '',
        shichangjia: ''
      },
      editFormsub: {
        Receiptterms: '',
        Receipttime: '',
        Receiptamount: ''
      }
    }
  },
  mounted () {
    this.PurchaseCompanyOptions = Vue.prototype.FunGetPurchaseCompany()
  },
  methods: {
    LoadData (row,ProjectNameList,SalesManList) {
      this.editForm.id = row.Id
      this.editForm.saletype = row.Saletype.toString()
      this.editForm.isdingzhi = row.Isdingzhi.toString()
      this.editForm.salecompany = row.Salecompany
      // this.editForm.projectcode = row.Projectcode
      // this.editForm.num = row.Num
      // this.editForm.unitprice = row.Unitprice
      // this.editForm.discountrate = row.Discountrate
      // this.editForm.shichangjia = row.Shichangjia
      this.editForm.salesmanid = row.Salesmanid
      this.editForm.customerid = row.Customerid
      this.editForm.gendanmanid = row.Gendanmanid
      this.editForm.amountoriginal = row.Amountoriginal
      this.editForm.amountrebates = row.Amountrebates
      this.editForm.amount  = row.Amount
      this.editForm.SubReceipt = row.Sublist
      this.editForm.SubProject = row.SubProjectlist
      this.editForm.sendtime = row.Sendtime
      this.editForm.sendaddress = row.Sendaddress
      this.editForm.beizhu = row.Beizhu
      this.editForm.dingzhifile = row.Dingzhifile
      this.editForm.attachment = row.Attachment
      this.$refs.MultiImgOrPdf.cleardata()

      this.ProjectNameList = ProjectNameList
      this.SalesManList = SalesManList
      this.apiGetErp6SaleBaseCustomerInfoListBySalesManId();

      console.log(this.editForm.SubProject)
    },
    processData (){
      var buf = Number(this.editForm.unitprice) / Number(this.editForm.shichangjia)
      this.editForm.discountrate = this.pnum(buf)
    },
    processAmount (){
      var buf = Number(this.editForm.amountoriginal) - Number(this.editForm.amountrebates)
      this.editForm.amount = this.pnum(buf)
    },
    pnum (num) {
      return Number(Number(num).toFixed(2))
    },
    clickAddSubProject () {
      if (!Vue.prototype.FunCheckNumber(this.editForm.num)) {
        Vue.prototype.FunAlertMsg('请输入数量')
        return
      }
      if (!Vue.prototype.FunCheckNumber(this.editForm.unitprice)) {
        Vue.prototype.FunAlertMsg('请输入单价')
        return
      }

      this.editForm.SubProject.push({
        Projectcode: this.editForm.projectcode,
        Projectname: this.editForm.projectname,
        Projectclassification: this.editForm.projectclassification,
        Num: parseInt(this.editForm.num),
        Unitprice: parseFloat(this.editForm.unitprice),
        Discountrate: this.editForm.discountrate,
        Shichangjia: this.editForm.shichangjia
      })
      this.countSubProject()
    },
    clickDeleteSubProject (index) {
      var buflist = []
      for (var j = 0, len = this.editForm.SubProject.length; j < len; j++) {
        if (index != j) {
          buflist.push(this.editForm.SubProject[j])
        }
      }
      this.editForm.SubProject = buflist
      this.countSubProject()
    },
    countSubProject(){
      this.editForm.amountoriginal = 0;
      for (var j = 0, len = this.editForm.SubProject.length; j < len; j++) {
        this.editForm.amountoriginal += this.pnum(this.editForm.SubProject[j].Num) * this.pnum(this.editForm.SubProject[j].Unitprice)
      }
    },
    clickAddSubReceipt () {
      if (this.editFormsub.Receiptterms.length <= 0) {
        Vue.prototype.FunAlertMsg('请输入收款条件')
        return
      }
      if (this.editFormsub.Receipttime.length <= 0) {
        Vue.prototype.FunAlertMsg('请输入收款时间')
        return
      }
      if (!Vue.prototype.FunCheckNumber(this.editFormsub.Receiptamount)) {
        Vue.prototype.FunAlertMsg('请输入收款金额')
        return
      }

      this.editForm.SubReceipt.push({
        Receiptterms: this.editFormsub.Receiptterms,
        Receipttime: this.editFormsub.Receipttime,
        Receiptamount: parseFloat(this.editFormsub.Receiptamount)
      })
    },
    clickDeleteSubReceipt (index) {
      var buflist = []
      for (var j = 0, len = this.editForm.SubReceipt.length; j < len; j++) {
        if (index != j) {
          buflist.push(this.editForm.SubReceipt[j])
        }
      }
      this.editForm.SubReceipt = buflist
    },
    clickReturn () {
      this.$emit('triggerFunc', '')
    },
    clickSave () {
      this.apiEditErp6SaleOrder()
    },
    dingzhifileTencentyunCosUploadMultiImgOrPdf (url) {
      this.editForm.dingzhifile = url
    },
    addTencentyunCosUploadMultiImgOrPdf (url) {
      this.editForm.attachment = url
    },
    selectProject () {
      this.apiGetErp6SaleBaseProductPriceByProjectcode()
    },
    selectSalesMan () {
      this.editForm.customerid = ''
      this.CustomerInfoList = []
      this.apiGetErp6SaleBaseCustomerInfoListBySalesManId()
    },
    // 获取产品的市场价
    apiGetErp6SaleBaseProductPriceByProjectcode: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        projectcode: that.editForm.projectcode
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetErp6SaleBaseProductPriceByProjectcode, Qs.stringify(data))
        .then(function (response) {
          console.log(response.data)
          if (response.data.Code === 200) {
            that.editForm.shichangjia = response.data.Shichangjia
            that.editForm.projectname = response.data.Projectname
            that.editForm.projectclassification = response.data.Projectclassification
            that.processData()
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    //为下拉框获取数据源--客户信息
    apiGetErp6SaleBaseCustomerInfoListBySalesManId: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        salesmanid: that.editForm.salesmanid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetErp6SaleBaseCustomerInfoListBySalesManId, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.CustomerInfoList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiEditErp6SaleOrder: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: that.editForm.id,
        saletype: that.editForm.saletype,
        isdingzhi: that.editForm.isdingzhi,
        salecompany: that.editForm.salecompany,
        // projectcode: that.editForm.projectcode,
        // num: that.editForm.num,
        // unitprice: that.editForm.unitprice,
        // discountrate: that.editForm.discountrate,
        // shichangjia: that.editForm.shichangjia,
        salesmanid: that.editForm.salesmanid,
        customerid: that.editForm.customerid,
        gendanmanid: that.editForm.gendanmanid,
        amountoriginal: that.editForm.amountoriginal,
        amountrebates: that.editForm.amountrebates,
        amount: that.editForm.amount,
        subreceipt: JSON.stringify(that.editForm.SubReceipt),
        sendtime: that.editForm.sendtime,
        sendaddress: that.editForm.sendaddress,
        beizhu: that.editForm.beizhu,
        dingzhifile: that.editForm.dingzhifile,
        attachment: that.editForm.attachment,
        subcustomername: that.editForm.subcustomername,
        sublianxifangshi: that.editForm.sublianxifangshi,
        subbankaccount: that.editForm.subbankaccount,
        subbankname: that.editForm.subbankname,
        subbeizhu: that.editForm.subbeizhu,
        subproject: JSON.stringify(that.editForm.SubProject)
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      console.log(data)
      axios.post(Vue.prototype.global.Url_EditErp6SaleOrder, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-button--mini, .el-button--mini.is-round {
    padding: auto 5px;
}
.select{
   width: 365px;
}
</style>
